export default "__VITE_ASSET__c266d5dc__"